import { create } from "zustand";

const getInitialState = () => {
  try {
    return {
      token: localStorage.getItem("has_session") || null,
      role: localStorage.getItem("role") || null,
      employeeId: localStorage.getItem("employee_id") || null,
      fullName: localStorage.getItem("full_name") || null,
      mustChangePassword: localStorage.getItem("must_change_password") === "true",
      isSuperuser: localStorage.getItem("is_superuser") === "true",
      profilePhoto: localStorage.getItem("profile_photo") || "/images/avatar.png",
      user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null,
    };
  } catch (e) {
    console.error("Failed to parse initial auth state from localStorage:", e);
    return {
      token: null,
      role: null,
      employeeId: null,
      fullName: null,
      mustChangePassword: false,
      isSuperuser: false,
      profilePhoto: "/images/avatar.png",
      user: null,
    };
  }
};

const useAuthStore = create((set) => ({
  ...getInitialState(),

  setAuth: (authData) => {
    // Sync with localStorage
    if (authData.token !== undefined) {
      if (authData.token === null) localStorage.removeItem("has_session");
      else localStorage.setItem("has_session", authData.token);
    }
    if (authData.role !== undefined) {
      if (authData.role === null) localStorage.removeItem("role");
      else localStorage.setItem("role", authData.role);
    }
    if (authData.employeeId !== undefined) {
      if (authData.employeeId === null) localStorage.removeItem("employee_id");
      else localStorage.setItem("employee_id", authData.employeeId);
    }
    if (authData.fullName !== undefined) {
      if (authData.fullName === null) localStorage.removeItem("full_name");
      else localStorage.setItem("full_name", authData.fullName);
    }
    if (authData.mustChangePassword !== undefined) {
      if (authData.mustChangePassword === null) localStorage.removeItem("must_change_password");
      else localStorage.setItem("must_change_password", String(authData.mustChangePassword));
    }
    if (authData.isSuperuser !== undefined) {
      if (authData.isSuperuser === null) localStorage.removeItem("is_superuser");
      else localStorage.setItem("is_superuser", String(authData.isSuperuser));
    }
    if (authData.user !== undefined) {
      if (authData.user === null) localStorage.removeItem("user");
      else localStorage.setItem("user", JSON.stringify(authData.user));
    }

    set((state) => ({
      ...state,
      ...authData,
    }));
  },

  setProfilePhoto: (photo) => {
    if (photo) {
      localStorage.setItem("profile_photo", photo);
    } else {
      localStorage.removeItem("profile_photo");
    }
    set({ profilePhoto: photo || "/images/avatar.png" });
  },

  clearAuth: () => {
    localStorage.removeItem("has_session");
    localStorage.removeItem("role");
    localStorage.removeItem("employee_id");
    localStorage.removeItem("full_name");
    localStorage.removeItem("must_change_password");
    localStorage.removeItem("is_superuser");
    localStorage.removeItem("user");
    localStorage.removeItem("profile_photo");

    set({
      token: null,
      role: null,
      employeeId: null,
      fullName: null,
      mustChangePassword: false,
      isSuperuser: false,
      profilePhoto: "/images/avatar.png",
      user: null,
    });
  },
}));

export default useAuthStore;
